/* global nubeeGlobals */

/*** Importations *********************************************************************************/

import objectFitImages from 'object-fit-images/dist/ofi.es-modules.js';
import smoothscroll from 'smoothscroll-polyfill';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock-upgrade';

// Libraries

import LazyLoad from 'vanilla-lazyload/dist/lazyload.esm.js';
import Swiper from 'swiper';
import {
	Autoplay,
	Pagination,
	Navigation,
	// EffectFade
} from 'swiper/modules';
import flatpickr from 'flatpickr';
import fr from "flatpickr/dist/l10n/fr.js";

// Scripts Nubee

import Tabs from 'partials/tabs.js';
import Accordion from 'partials/accordion.js';
import * as functions from 'partials/functions.js';
import 'partials/scroll-interval.js';
import 'partials/target-blank-security.js';
import GLightboxNubee from 'partials/glightbox-nubee.js';
import googleMapStyles from 'data/google-map-styles.js';
import GoogleMap from 'partials/google-map.js';
import MobileMenu from 'partials/mobile-menu.js';
import imgCheck from 'partials/img-check.js';
import InfiniteScrollSimple from 'partials/infinite-scroll-simple.js';
import LoadingButton from 'partials/loading-button.js';
import * as cookiesBar from 'partials/cookies-bar.js';

// Inclusion pour ajouter des fonctions à Gravity Forms
import GravityFormsConditionalLogic from 'partials/gf-conditional-logic.js';
import initFlatpickr from 'partials/init-flatpickr.js';
import NumberInput from 'partials/number-input.js';

// On set toutes les variables globales et évènements qui les modifient ici
import * as globalVarFunctions from 'partials/global-variables.js';

(function() {
	/*** Application des polyfills ********************************************************************/

	(function() {
		objectFitImages();
		smoothscroll.polyfill();

		if( 'function' != typeof window.Event ) {
			window.Event = CustomEvent;
		}
	}) ();


	/*** Variables globales ***************************************************************************/
	// global-variables.js
	// Chaînes traduisibles et autres variables provenant de theme-functions : window.nubeeGlobals.i18n.monPlugin.nomDeChaine
	
	globalVarFunctions.setGlobalVariables();
	
	/*** Déclancher l'affichage des éléments masqué par défaut ***************************************************************************/
	(function() {

		setTimeout( function() {
			document.body.classList.add( 'show-hidden-elements' );
		}, 500 );

	}) ();

	/*** Les liens avec ancre qui mènent vers la même page deviennent seulement des ancres *******************/
	// Requiert functions.urlsAreSamePage
	// Requiert functions.arrayAllEqual

	(function() {
		let linksWithHash = document.querySelectorAll('a[href*="#"]');

		linksWithHash.forEach( function( thisLink ) {
			if( functions.urlsAreSamePage({ urls: [ thisLink.href, window.location.href ] }) ) {
				thisLink.href = thisLink.hash;
			}
		} );
	}) ();


	/*** Défiler doucement les liens ancres *******************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js
	// Ajuster la variable globale window.fixedElHeight

	(function() {
		if( window.smoothScroller ) {
			let smoothScrollLinks = document.querySelectorAll('a[href^="#"]:not([href="#"]):not(.no-smooth-scroll):not([target])');

			smoothScrollLinks.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.addEventListener( 'click', function( event ) {
						if( 1 == event.which ) {
							event.preventDefault();
							window.smoothScroller.scrollTo({ target: thisEl.hash });
						}
					} );
				}
			});
		}
	}) ();


	/*** Ne rien faire au clic sur un lien vide (#) ************************************************************/

	(function() {
		document.addEventListener( 'click', function( event ) {
			if( 1 == event.which ) {
				let linkClicked = event.target.closest('a');
				let theHref = linkClicked ? linkClicked.getAttribute('href') : null;

				if( linkClicked && ( ! theHref || '#' == theHref ) && functions.scriptsOk( linkClicked ) ) {
					event.preventDefault();
				}
			}
		} );
	}) ();


	/*** Images et backgrounds différents selon la taille de l'écran ********************************/
	// Requiert img-check.js

	(function() {
		if( 'function' == typeof imgCheck ) {
			window.addEventListener( 'resize', imgCheck );
			imgCheck();
		}
	}) ();


	/*** Lazy load des images et backgrounds *******************************************************************/
	// Requiert vanilla-lazyload

	(function() {
		let loadedEvent = new Event( 'lazyloaded' );

		window.siteLazyLoad = new LazyLoad({
			elements_selector: '.lazy',
			class_loading: 'lazy-loading',
			class_loaded: 'lazy-loaded',
			class_error: 'lazy-error',
			// use_native: true,
			callback_loaded: function( element ) {
				element.dispatchEvent( loadedEvent );
			},
		});
	}) ();


	/*** Google Maps ******************************************************************************************/
	// Requiert google-map.js
	// Requiert data/google-map-styles.js (copier-coller votre style là-dedans!)

	(function() {
		let mapParents = document.querySelectorAll('.the-map');

		mapParents.forEach( function( thisParent ) {
			if( functions.scriptsOk( thisParent ) ) {
				new GoogleMap({
					mapParent: thisParent,
					styles: googleMapStyles,
					mapTypeId: 'terrain',
					zoom: 13,
					markerIconUrl: window.nubeeGlobals.themeDir + '/assets/images/map-marker.svg'
				});
			}
		} );
	}) ();

	/*** Antispam maison sur les commentaires ****************************************************************/
	// À moins d'avoir activé le JS, la validation PHP refusera le commentaire.

	(function() {
		let commentForms = document.querySelectorAll('#commentform');

		commentForms.forEach( function( thisForm ) {
			thisForm.addEventListener( 'submit', function() {
				let legitInput = document.createElement( 'input' );
				legitInput.setAttribute( 'type', 'hidden' );
				legitInput.setAttribute( 'name', 'is_legit' );
				legitInput.value = 1;

				thisForm.appendChild( legitInput );
			} );
		} );
	}) ();


	/*** Gravity Forms : Faire fonctionner les trucs qui ne fonctionne plus suite à la désactivation de jQuery **/
	(function() {
		// Mettre les label Gravity Forms en mode focus quand ils ont une valeur
		document.querySelectorAll( '.gfield, .page-block-product .nyp, .voucher-fields-wrapper .form-row, .woocommerce form .form-row' ).forEach( function( thisFormRow ) {
			thisFormRow.querySelectorAll( 'input:not([type="checkbox"]):not([type="radio"]), textarea, select' ).forEach( function( thisField ) {
				// console.log( thisField.placeholder );
				setTimeout( function() {
					if( thisField.value !== '' || ( thisField.placeholder !== '' && thisField.placeholder !== undefined ) ) { thisFormRow.classList.add( 'has-value' ); }
				}, 100 );

				thisField.addEventListener( 'change', function(){
					if( thisField.value !== '' || ( thisField.placeholder !== '' && thisField.placeholder !== undefined ) ) {
						thisFormRow.classList.add( 'has-value' );
					} else {
						thisFormRow.classList.remove( 'has-value' );
					}
				} );
			} );
		} );

		// Désactiver le bouton après un click dans les formulaires Gravity Forms
		document.querySelectorAll( '.gform_button' ).forEach( function( thisButton ) {
			thisButton.addEventListener( 'click', function() {
				thisButton.closest('form').submit();
				thisButton.disabled = true;
			} );
		} );

		// Si on a un gravityForms avec un file upload dans la page, on le bind sur notre script pour gérer tout ça
		document.querySelectorAll( '.gform_wrapper form' ).forEach( function( theForm, index ) {

			if( theForm.querySelectorAll( '.gform_fileupload_multifile' ).length <= 0 ) {
				return;
			}

			nubeeGFDropzone.nubeeGFDropzone( theForm.dataset.formid, 'customDropzone-' + index );
		});

		// On va faire fonctionner le système de logique conditionnelles
		document.querySelectorAll( '.gform_wrapper > form' ).forEach( function( thisForm ) {
			new GravityFormsConditionalLogic( thisForm );
		});

		document.querySelectorAll( '.gform_wrapper > form input[value="gf_other_choice"]' ).forEach( function( thisRadio ) {
			thisRadio.addEventListener( 'change', function() {
				const wrapper = thisRadio.closest('.gchoice');

				const otherInput = wrapper ? wrapper.querySelector('.gchoice_other_control') : null;

				if( !otherInput ) return;

				// Fonction pour activer/désactiver en fonction de l'état du bouton radio
				otherInput.disabled = ! thisRadio.checked;

				if( ! otherInput.disabled ) {
					otherInput.value = ''; // vider le champ s’il est désactivé
					otherInput.focus();
				}
			} );
		});
	}) ();


	/*** Retour en haut **************************************************************************************/
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let backToTop = document.querySelector('.back-to-top');

		if( backToTop && functions.scriptsOk( backToTop ) ) {
			backToTop.addEventListener( 'click', function() {
				if( 1 == event.which ) {
					window.smoothScroller.scrollTo({ target: document.body });
				}
			} );
		}
	}) ();


	/*** Menu mobile maison **********************************************************************************/

	(function() {
		new MobileMenu({
			menuSel: '.mobile-menu',
			buttonSel: '.mobile-menu-button',
			// debug: true,
			dropdownParentLinkActive: false,

			// Si on agrandit la fenêtre dans ce media query, le menu se ferme automatiquement.
			closeMediaQuery: '(min-width: 1000px)',

			// viewportMax: { width: 699 },
		});
	}) ();


	/*** InfiniteScrollSimple - Version maison plus légère *************************************************/
	// Requiert infinite-scroll-simple.js
	// Requiert regenerator-runtime (Babel veut ça pour les fonctions async)
	// Voir le début du fichier pour des events sur lesquels vous hooker

	(function() {
		let infiniteContainers = document.querySelectorAll('.iss-container');

		infiniteContainers.forEach(function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new InfiniteScrollSimple({
					container: thisEl,
					useInner: true,
					animate: true,
					hideButton: false,
					// debug: true,
				});
			}
		} );

	}) ();


	/*** LoadingButton - bouton pour AJAX avec preloader intégré *******************************************/

	(function() {
		let buttons = document.querySelectorAll('.loading-button');

	 	buttons.forEach(function( thisEl ) {
	 		if( functions.scriptsOk( thisEl ) ) {
	 			new LoadingButton({
	 				buttonEl: thisEl,
	 				debug: false,
	 			});

	 			// Le bouton est maintenant initialisé. On peut l'activer avec les méthodes :
	 			// buttonInstance.loadingStart() | buttonInstance.loadingEnd()
	 			// Fonctionnent aussi :
	 			// thisEl._loadingButton.loadingStart() | thisEl._loadingButton.loadingEnd()
	 		}
	 	} );
	 }) ();


	/*** Sliders Swiper Partners ********************************************************************************/
	// Requiert Swiper

	(function() {
		let post_list_slider = document.querySelectorAll('.page-block-post-list-slider');

		post_list_slider.forEach( function( thisSlider ) {

			let swiper = thisSlider.querySelector( '.swiper' ),
				swiperNextEl = thisSlider.querySelector( '.swiper-button-next' ),
				swiperPrevEl = thisSlider.querySelector( '.swiper-button-prev' );

			new Swiper( swiper, {
				modules: [ Navigation, Autoplay ],
				speed: 400,
				spaceBetween: 20,
				slidesPerView: 1,
				direction: 'horizontal',
				loop: true,
				preventInteractionOnTransition: true,
				preventClicks: false,
				preventClicksPropagation: true,
				effect: 'slide',
				preloadImages: true,
				shortSwipes: true,
				lazy: {
					loadPrevNext: true,
				},
				navigation: {
					nextEl: swiperNextEl,
					prevEl: swiperPrevEl,
				},
				on: {
					beforeLoopFix: function( ) {
						window.siteLazyLoad.update();
					}
				},
				breakpoints: {
					500: { slidesPerView: 2, },
				},
			});

		});
	}) ();

	/*** Empêcher la taille d'un élément de se réajuster une fois le chargement terminé ***********************/

	(function() {
		let lockedHeightEls = document.querySelectorAll('.lock-height-on-load');

		window.addEventListener( 'load', function() {
			lockedHeightEls.forEach( function( thisEl ) {
				if( functions.scriptsOk( thisEl ) ) {
					thisEl.style.height = thisEl.offsetHeight + 'px';
					thisEl.style.minHeight = 0;
					thisEl.style.maxHeight = 'none';
				}
			} );
		} );
	}) ();

	/*** Défile doucement au chargement d'une URL avec ancre ***************************************************/
	// Évènement "hashblocked" pour dire que le jump par défaut vient d'être bloqué
	// Évènement "initialscrollstart" pour dire qu'on s'apprête à faire le scroll
	// Évènement "initialscrollend" pour dire que la page est chargée ET l'ancre active est scrollée
	// S'il n'y a pas d'ancre (#) active, l'évènement est lancé dès le chargement.
	// Requiert window.smoothScroller (smooth-scroller.js), initialisé dans global-variables.js

	(function() {
		let origHash = window.location.hash;
		let hashBlockedEvent = new Event( 'hashblocked' );
		let scrollStartEvent = new Event( 'initialscrollstart' );
		let scrollEndEvent = new Event( 'initialscrollend' );

		if( origHash ) {
			let targetEl = document.querySelector( origHash );

			if( targetEl ) {
				window.addEventListener( 'hashblocked', function() {
					window.addEventListener( 'smoothscrollend', function initialScrollEnd() {
						window.dispatchEvent( scrollEndEvent );
						window.removeEventListener( 'smoothscrollend', initialScrollEnd );
					} );

					window.dispatchEvent( scrollStartEvent );

					window.smoothScroller.scrollTo({
						target: origHash,
						historyState: history.state,
						historyAction: 'replace',
						// debug: true,
					});
				} );


				// Blocage du jump du navigateur par défaut
				setTimeout( function() {
					functions.changeHashWithoutScrolling( null, history.state, 'replace' );
					window.scrollTo( 0, 0 );
					window.dispatchEvent( hashBlockedEvent );
				}, 1 );
			} else {
				window.dispatchEvent( scrollEndEvent );
			}
		} else {
			window.dispatchEvent( scrollEndEvent );
		}
	}) ();

	/*** ProgressiveFadeIn - effet d'apparition lorsque dans le viewport *****************************************/
	// Requiert functions.progressiveFadeIn
	// Options dans progressive-fade-in.scss
	(function() {
		let fadeInItems = document.querySelectorAll('.progressive-fade-in');

		fadeInItems.forEach( function( thisEl ) {
			functions.progressiveFadeIn( thisEl );

			window.addEventListener( 'scrollinterval', function() {
				functions.progressiveFadeIn( thisEl );
			} );
		} );
	}) ();



	/*** Onglets ***************************************************************************************/
	// Requiert tabs.js


	(function() {
		document.querySelectorAll('.tabs-block').forEach( function( thisEl ) {
			new Tabs({
				container: thisEl,
				debug: false,
			});
		} );
	}) ();


	/*** Accordion *************************************************************************************/
	// Requiert accordion.js


	(function() {
		let accordionsEl = document.querySelectorAll('.accordion .accordion-item');

		accordionsEl.forEach( function( el ) {
			new Accordion( el );
		} );
	}) ();

	/*** Lightbox et popups avec GLightbox ******************************************************************/
	// Requiert GLightbox (glightbox)
	// Requiert glightbox-nubee.js

	(function() {
		// Éléments seuls.
		let lightboxEls = document.querySelectorAll('.lightbox');
		lightboxEls.forEach( function( thisEl ) {
			if( functions.scriptsOk( thisEl ) ) {
				new GLightboxNubee({
					links: thisEl,
					// debug: true,
				});
			}
		} );

		// Galeries. (Attention de donner une classe différente à chaque galerie de la page.)
		// Utilisez data-lightbox-element-class="ma-classe" sur .lightbox-gallery pour l'identifier.
		let lightboxGals = document.querySelectorAll('.lightbox-gallery');
		lightboxGals.forEach( function( thisGal ) {
			if( functions.scriptsOk( thisGal ) ) {
				new GLightboxNubee({
					galleryParent: thisGal,
					// debug: true,
				});
			}
		} );

		// On peut maintenant accéder aux instances à partir des liens ou du parent de la galerie :
		// <un lien lightbox ou un div galerie>._GLightboxNubee
		// <un lien lightbox ou un div galerie>._GLightbox
	}) ();


	/*** Boutons +/- des input type number *******************************************************************/
	// Requiert NumberInput (number-input.js)


	(function() {
		NumberInput.initAll( '.input-number' );
	}) ();



	/*** Datepickers avec flatpickr ***************************************************************************/
	// Requiert initFlatpickr (init-flatpickr.js)
	// Requiert flatpickr

	(function() {
		let dateFields = document.querySelectorAll('.date-picker');

		dateFields.forEach( function( thisField ) {
			initFlatpickr( thisField );
		} );

	}) ();

	/*** Gestion des préférence de cookies ***************************************/
	(function() {
		window.acceptedCookies = cookiesBar.getCookie('acceptedCookies');

		if( 'function' == typeof cookiesBar.cookieConsent ) {
			cookiesBar.cookieConsent();
		}
	}) ();


	// Email & phone link de-obfuscation (vanilla, no inline script, with semicolons)
	(function() {
		function decodeBase64( s ) {
			try { return atob( s ); } catch (e) { return ''; }
		}

		function hydratePhone( root ) {
			var els = (root || document).querySelectorAll('.nubee-tel-obf[data-tel]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var tel = decodeBase64(el.getAttribute('data-tel'));
				if (!tel) { continue; }
				el.setAttribute('href', 'tel:' + tel);
				if (!el.getAttribute('title')) { el.setAttribute('title', tel); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateMail( root ) {
			var els = (root || document).querySelectorAll('.nubee-mail-obf[data-mail]');
			for (var i = 0; i < els.length; i++) {
				var el = els[i];
				if (el.dataset.nubeeHydrated === '1') { continue; }
				var mail = decodeBase64(el.getAttribute('data-mail'));
				if (!mail) { continue; }
				el.setAttribute('href', 'mailto:' + mail);
				if (!el.getAttribute('title')) { el.setAttribute('title', mail); }
				el.dataset.nubeeHydrated = '1';
			}
		}

		function hydrateAll( root ) {
			hydratePhone( root );
			hydrateMail( root );
		}

		// Public APIs if you need to call them manually
		window.nubeeTelDeobfuscate = function() { hydratePhone(document); };
		window.nubeeMailDeobfuscate = function() { hydrateMail(document); };
		window.nubeeContactDeobfuscate = function() { hydrateAll(document); };

		// Auto-init on DOM ready
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', function() { hydrateAll(document); });
		} else {
			hydrateAll(document);
		}

		// Optional: handle content injected after load (AJAX, etc.)
		if ('MutationObserver' in window) {
			var mo = new MutationObserver(function(mutations) {
				for (var i = 0; i < mutations.length; i++) {
					for (var j = 0; j < mutations[i].addedNodes.length; j++) {
						var node = mutations[i].addedNodes[j];
						if (node && node.nodeType === 1) { hydrateAll(node); }
					}
				}
			});
			mo.observe(document.documentElement, { childList: true, subtree: true });
		}

		// Safety: prevent navigation if not yet hydrated
		document.addEventListener('click', function( e ) {
			var a = e.target.closest('a.nubee-tel-obf, a.nubee-mail-obf');
			if (!a) { return; }
			if (!a.getAttribute('href') || a.getAttribute('href') === '#') {
				e.preventDefault();
			}
		}, true);
	})();

	// Code pour le popup de booking form mobile
	(function() {
		const bookingFormPopup = document.querySelector('.booking-form-popup');

		if( bookingFormPopup /* window.vWidth < 1000 */ ) {
			const bookingFormPopupInner = bookingFormPopup.querySelector('.booking-form-popup-inner'),
				bookingFormPopupBtn = document.querySelector('.booking-form-popup-opener .popup-opener'),
				siteHeader = document.querySelector('.site-header');

			bookingFormPopupBtn.addEventListener( 'click', function( event ) {
				event.preventDefault();

				if( bookingFormPopup.classList.contains( 'closed' ) ) {

					disableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
					siteHeader.style.zIndex = 1;
					bookingFormPopup.classList.remove('closed');

				} else {

					enableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
					bookingFormPopup.classList.add('closed');

					siteHeader.style.zIndex = 190;

				}
			} );

			bookingFormPopup.querySelector('.close-popup').addEventListener( 'click', function( event ) {
				event.preventDefault();

				enableBodyScroll( bookingFormPopupInner, { reserveScrollBarGap: true } );
				bookingFormPopup.classList.add('closed');

				siteHeader.style.zIndex = 190;
			} );
		}
	})();

	/*** Charger le vidéo d'accueil, s'il y en a un **************************************************/
	(function () {
		// Respecte le réglage "Réduire les animations"
		var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		// Respecte les économies de données / connexions lentes
		var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
		var saveData = conn && (conn.saveData || (conn.effectiveType && /2g/.test(conn.effectiveType)));

		if (prefersReduced || saveData) {
			// On garde seulement le poster; pas de vidéo
			return;
		}

		var section = document.querySelector('.hero-bg-video' );
		var iframe = section && section.querySelector( '.hero-bg-video__iframe' );

		if (!section || !iframe) {
			return;
		}

		function loadIframe() {
			if( iframe.dataset.src && ! iframe.src ) {
				iframe.src = iframe.dataset.src;

				iframe.addEventListener('load', function () {
					section.classList.add( 'hero-bg-video--ready' );

					// On peut retirer le poster pour ne pas doubler le décodage
					var poster = section.querySelector('.hero-bg-video__poster');

					if( poster ) {
						poster.style.display = 'none';
					}
				}, { once: true });
			}
		}

		// Charge uniquement si visible (ou presque)
		if( 'IntersectionObserver' in window ) {
			var io = new IntersectionObserver( function ( entries ) {
				entries.forEach( function ( entry ) {
					if( entry.isIntersecting || entry.intersectionRatio > 0 ) {
						loadIframe();
						io.disconnect();
					}
				});
			}, { rootMargin: '200px' });
			io.observe( section );
		} else {
			// Fallback : charge après un petit délai
			setTimeout( loadIframe, 800 );
		}

	})();

	/* traquer les clics du bouton réservez sur GA4 */
	(function () {
		document.addEventListener('DOMContentLoaded', function () {
			const forms = document.querySelectorAll('.booking-form form');

			console.log('booking gtag init', forms.length);

			forms.forEach(form => {
				form.addEventListener('submit', () => {
					console.log('Booking form submitted');

					if( typeof window.gtag === 'function' ) {
						console.log('gtag found');

						window.gtag('event', 'booking_click', {
							event_category: 'Booking',
							event_label: 'Reservation'
						});
					}
				});
			});
		});
	})();

}) ();